<template>
  <div class="box12">
    <pageTitle title="你可能还想了解" text />

    <commomProblem
      class="box"
      :problemData="problemData"
      :styleData="styleData"
    />
    <div class="btn" @click="zixun('了解更多')">了解更多</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "学这门课，对硬件有什么要求吗？",
          answer:["本课程由趋动云提供算力支持，入营用户免费提供哦入~(如无算力支持，则个人电脑需要NVIDIA显卡或者GPU云服务器，至少16GB以上显存)"]
        },
        {
          title: "课程模式是怎样的？",
          answer:["课程采用纯直播形式，有专属学习交流群和班主任全程陪伴式学习，保障学习效果。"]
        },
        {
          title: "课程和其他机构的有什么区别？",
          answer:["课程和头部大厂联合共创，以真实的企业环境为背景，通过项目制形式融会贯通整个大模型技术知识，让你在短时间内快速掌握主流大模型架构及原理并加以企业应用。"]
        },
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/java/box11/icon.png"),
      },
    };
  },
  methods: {
    zixun(name) {
      this.mai("AI大模型训练营","了解更多",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box12 {
  padding: 80px 0px 60px;
  width: 100%;
  background: url("../../../assets/coursePage/softwareTest/box15/bg.png")
    no-repeat;
  background-size: cover;

  .box {
    margin-top: 48px;
    ::v-deep {
      .item-answer {
        display: inline-block;
      }
    }
  }
  .btn {
    margin: 0 auto;
    margin-top: 48px;
    width: 686px;
    height: 96px;
    background: linear-gradient(270deg, #4eacff 0%, #2674ff 100%);
    border-radius: 48px;
    text-align: center;
    font-size: 30px;
    line-height: 96px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
